/**Different sources for values returned from CachedApi */
export enum DataSource {
    API = 'api',
    Storage = 'storage'
}
